<template>
  <div class="col-md-12">
    <div class="card">
      <form>
        <div class="card-header">
          <h4 class="card-title">
            {{ title }}
          </h4>
        </div>
        <div class="card-content">
          <div class="form-group">
            <label>Nome</label>
            <input type="text"
                   name="name"
                   v-validate="modelValidations.name"
                   v-model="model.name"
                   class="form-control">
            <small class="text-danger"
                   v-show="name.invalid">
              {{ getError('name') }}
            </small>
          </div>
          <div class="form-group">
            <label>Texto informartivo</label>
            <textarea rows="3"
                      name="informativeText"
                      v-validate="modelValidations.informativeText"
                      v-model="model.informativeText"
                      class="form-control"></textarea>
            <p class="text-right help-block">
              <small> {{ `${model.informativeText.length} / 600` }}</small>
            </p>
            <small class="text-danger"
                   v-show="informativeText.invalid">
              {{ getError('informativeText') }}
            </small>
          </div>
        </div>
        <div class="card-footer text-right">
          <button type="submit"
                  :disabled="saving"
                  @click.prevent="handleSave()"
                  class="btn btn-fill btn-success btn-wd"><i class="ti-save"></i> Salvar
          </button>
        </div>
      </form>

    </div>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import {mapActions, mapGetters} from 'vuex'

  export default {
    data () {
      return {
        saving: false,
        indexPath: { name: 'manufacturers.index' },
        entityName: 'Fabricante'
      }
    },
    computed: {
      ...mapFields([
        'name',
        'informativeText'
      ]),
      ...mapGetters('manufacturers', {
        model: 'manufacturer',
        modelValidations: 'validations',
        loading: 'loading'
      }),
      id () {
        return this.$route.params.id
      },
      editing () {
        return this.id !== undefined
      },
      title () {
        return this.editing ? `Editar ${this.entityName}` : `Novo ${this.entityName}`
      }
    },
    created () {
      if (this.editing) {
        this.fetchOne(this.id)
      } else {
        this.resetOne()
      }
    },
    methods: {
      ...mapActions('manufacturers', [
        'fetchOne',
        'resetOne',
        'insert',
        'update'
      ]),
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      handleSave () {
        this.saving = true
        this.$validator.validateAll()
          .then(isValid => {
            if (isValid) {
              let doc = Object.assign({}, this.model)
              doc.collection = 'manufacturers'
              if (this.editing) {
                this.update(doc)
                  .then(result => {
                    this.saving = false
                    this.$notify({
                      message: 'Registro editado com sucesso.',
                      type: 'success'
                    })
                    this.$router.push(this.indexPath)
                  })
                  .catch(err => {
                    this.saving = false
                    console.log(err)
                  })
              } else {
                this.insert(doc)
                  .then(result => {
                    this.saving = false
                    this.$notify({
                      message: 'Registro criado com sucesso.',
                      type: 'success'
                    })
                    this.$router.push(this.indexPath)
                  })
                  .catch(err => {
                    this.saving = false
                    console.log(err)
                  })
              }
            }
          })
          .catch(err => {
            this.saving = false
            console.log(err)
          })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Manufacturers/ManufacturersForm.vue